import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MakePaymentComponent } from './make-payment/make-payment.component';
import { MaterialModule } from '../material/material.module';
import { CreditCardDisplayComponent } from './credit-card-display/credit-card-display.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        SharedModule,
        MakePaymentComponent,
        CreditCardDisplayComponent
    ]
})
export class PaymentModule {
}
